export default __webpack_public_path__ + "static/media/clock.59541381.svg";